module.exports = __webpack_public_path__ + "assets/img/images_b.2a13d4d6.png";